import NavDropdown from "./NavDropdown";

const dataPenggunaDropdownItems = [
  ["Admin", "/data/admin"],
  ["Manajer", "/data/manajer"],
  // ["Staf", "/data/staf"],
  ["Dosen", "/data/dosen"],
  ["Dosen - Jadwal Pribadi", "/data/dosen/jadwal-pribadi"],
  ["Mahasiswa", "/data/mahasiswa"],
];

const dataSidangDropdownItems = [
  ["Peserta MK Spesial", "/sidang/mk-spesial"],
  ["Jadwal Sidang", "/sidang/jadwal-sidang"],
  ["Deadline", "/sidang/deadline"],
  ["Ruangan", "/sidang/ruangan"],
  ["Jadwal Ruangan", "/sidang/jadwal-ruangan"],
  ["Semester", "/sidang/semester"],
  ["Laporan", "/sidang/laporan"],
  ["Log", "/sidang/log"],
];

export function AdminNavbar() {
  return (
    <>
      <NavDropdown
        label="Kelola Pengguna"
        dropdownItems={dataPenggunaDropdownItems}
      />
      <NavDropdown
        label="Kelola Sidang"
        dropdownItems={dataSidangDropdownItems}
      />
    </>
  );
}
